export const TAG_SHOW_TABS = [
  'general',
  'publications',
  'collection',
  'search',
] as const;

export type TagShowTab = (typeof TAG_SHOW_TABS)[number];

export const TAG_DEFAULT_TAB: TagShowTab = 'general';
